/**
 * Created by gk-lab on 03.02.17.
 */
import React, { Component } from 'react';
import './ExpandableText.css';

class ExpandableText extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };

    }

    componentDidMount() {
        //this.setState({expanded: !this.props.expanded});
    }

    static propTypes =  {
        onChange:   React.PropTypes.func,
        headline:React.PropTypes.string,
        text:React.PropTypes.string,
        text_short:React.PropTypes.string,
        isExpanded:React.PropTypes.bool,
    }

    handleClick = (e) =>  {

        this.setState({expanded: !this.state.expanded});
        if (typeof this.props.onChange === 'function') {
            //this.props.onChange();
        }
    }

    componentWillReceiveProps (nextProps) {

        if (nextProps.text_short === "") {
            this.setState({expanded: true});
        } else {
            this.setState({expanded: false});
        }

    }


  render() {

    if (this.props.text_short === "" && !this.state.expanded) {
        this.setState({expanded: true});

    }

    return (
        <div className="ExpandableText" >
            <span className="headline" dangerouslySetInnerHTML={{__html: this.props.headline}}></span>

            <div>
                {
                    !this.state.expanded &&
                    <span dangerouslySetInnerHTML={{__html: this.props.text_short}}></span>
                }
                {
                    !this.state.expanded && this.props.text_short !== "" &&
                    <span className="link" onClick={(e) => this.handleClick(e)} >
                    <i className="material-icons">keyboard_arrow_down</i>
                    Weiterlesen
                    </span>
                }

            </div>


            <div>

                {
                    this.state.expanded &&
                    <span dangerouslySetInnerHTML={{__html: this.props.text}}></span>
                }
                {
                    this.state.expanded && this.props.text_short !== "" &&
                    <span className="link" onClick={(e) => this.handleClick(e)} >
                        <i className="material-icons">keyboard_arrow_up</i>
                        Weniger
                    </span>

                }
            </div>
        </div>
    );
  }
}

export default ExpandableText;



// WEBPACK FOOTER //
// ./src/components/ExpandableText/ExpandableText.js